angular.module('core')
  .service('tableSort', ['$state', '$location', '$rootScope', '$filter', function($state, $location, $rootScope, $filter) {
    var publics = {};

    publics.DEFAULT_COLUMN_INDEX = 1; // name or first_name
    publics.ASCENDING = 'asc';
    publics.DESCENDING = 'desc';
    publics.sortIndex = publics.DEFAULT_COLUMN_INDEX;
    publics.sort = {
      column: null,
      order: publics.ASCENDING
    };

    var goToState = function() {
      var toParams = {};
      if (publics.sort.column) {
        toParams = {
          'sort': publics.activeColumnId,
          'order': publics.sort.order
        };
      }
      $state.go('.', toParams, {
        notify: false,
        location: 'replace'
      }).then(function() {
        $rootScope.$broadcast('updateSortableTable', publics.activeColumnId);
      });
    };

    // Handle time period dropdown.
    publics.handleSortOptionClick = function(sortOption) {
      publics.sort.column = sortOption;
      publics.sort.order = sortOption.order;
      publics.activeColumnId = sortOption.id;
      goToState();
    };

    publics.handleColumnClick = function(column) {
      if (!column.sortType) {
        return;
      }
      // Check if tab your selecting is already highlighted
      if (publics.sort.column !== null && publics.sort.column.id === column.id) {
        publics.sort.order = publics.sort.order === publics.ASCENDING ? publics.DESCENDING : publics.ASCENDING;
      } else {
        publics.sort.column = column;
        publics.sort.order = column.sortOrder ? column.sortOrder : publics.ASCENDING;
      }
      publics.activeColumnId = column.id;
      goToState();
    };

    publics.sortColumn = function(listTableColumns, listTableData) {
      if (!listTableColumns || !listTableData || listTableData.length === 0) {
        return;
      }
      var columnName = $state.params.sort || listTableColumns[publics.sortIndex].id;
      var localRows = angular.copy(listTableData);
      var sorted = $filter('orderBy')(localRows, columnName, $state.params.order === 'desc');
      return sorted;
    };

    // Sort by a property in the data even if it isn't part of the defined table column set
    publics.sortByColumn = function (listTableData, columnName) {
      var localRows = angular.copy(listTableData);
      var sorted = $filter('orderBy')(localRows, columnName, $state.params.order === 'desc');
      return sorted;
    };

    publics.initializeSort = function(columns) {
      if (_.isArray(columns) && columns.length > 0) {
        if ($state.params.order && $state.params.sort) {
          // Page is reloaded with a param set
          var columnIndex = _.findIndex(columns, {
            id: $state.params.sort
          });
          if (columnIndex === -1) {
            // Do nothing
            console.error('no column set');
          } else {
            publics.sort.column = columns[columnIndex];
            publics.sort.order = $state.params.order;
            publics.activeColumnId = publics.sort.column.id;
          }
        } else {
          // Sort by either the designated default column, or the column designated by the default sort index.
          // Account for default sortOrder.
          var defaultColumn = publics.getDefaultColumn(columns);
          var sortColumn = defaultColumn || columns[publics.sortIndex];
          publics.sort.column = sortColumn;
          publics.sort.order = sortColumn.sortOrder || publics.ASCENDING;
          publics.activeColumnId = sortColumn.id;

          goToState();
        }
      }
    };

    // Return the first column marked as default. Returns undefined if there is no column marked as default.
    publics.getDefaultColumn = function(columns) {
        return _.find(columns, function(column){
            return column.default;
        });
    };

    return publics;

  }]);
